<template>
  <div class="agreement-container">
    <div class="agreement-content" v-html="agreementText"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      agreementText:
	  `
	  麦小通用户服务协议
	  欢迎您与麦小通（详见定义条款）共同签署本《用户服务协议》（下称“本协议”）并使用麦小通相关服务。
	  麦小通在此特别提醒用户认真阅读、充分理解本协议中各条款，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以重点文字标识，您应重点阅读。如您对本协议内容或页面提示信息有疑问，请勿进行下一步操作。
	  您的登录、使用等行为将视为您已对本协议充分阅读、理解并接受本协议的全部内容，并与麦小通达成一致，成为麦小通的“用户”。
	  如果您未完成账号开通流程，或者在本协议生效前已成为麦小通的注册用户，则您名下任何账户通过访问和/或使用麦小通系统，即视为您表示同意接受本协议的全部内容，否则请您停止访问或使用麦小通服务。
	  1. 定义
	  1.1 麦小通系统：指杭州麦田熊科技有限公司合法所有或运营的麦小通 App 及配套后台管理系统。
	  1.2 麦小通服务：指麦小通通过上述 App 系统，向用户提供的 B 端供应链订货、调货、报损、对账等相关业务服务。
	  1.3 用户：指获得麦小通账号，使用麦小通订货、调货、报损、对账等服务的线下门店经营者、门店授权操作人员。
	  1.4 合作仓库：指为门店提供货品仓储、分拣、配送的第三方供货仓储合作方，麦小通仅提供线上信息交易服务，不直接生产、持有货品。
	  2. 账户的开通、使用和注销
	  2.1 用户资格
	  2.1.1 您确认，在您开始使用麦小通服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力；如为企业/个体工商户门店，则代表您已经获得门店主体的完整授权，可以代表门店开展订货业务。若您不具备前述民事行为能力或授权，则您及相关主体应依照法律规定承担因此而导致的一切后果。
	  2.1.2 本平台为B端商户工具，不对普通个人消费者开放使用。
	  2.2 账户说明
	  2.2.1 麦小通采用商户准入模式，账号由平台审核后分配开通，不支持用户自主注册。当门店完成商户准入审核，分配账号、阅读并同意本协议及《麦小通隐私政策》后，方可获得麦小通账号并成为麦小通的用户。
	  2.2.2 您有权使用分配的账号、手机号码及您设置的密码登录麦小通系统。
	  2.2.3 由于用户账户关联门店经营信息，仅当有法律明文规定、司法裁定或经麦小通书面同意，并符合麦小通相关规则规定的用户账户转让流程的情况下，您才可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您的账户不得以任何方式转让、出借、售卖，否则由此产生的一切责任均由门店及实际使用人承担。
	  2.2.4 为使您更好地使用麦小通的各项服务，我们建议您按照相关法律法规规定及我们产品页面的提示完成门店资质认证。
	  2.2.5 如您的账户长期未登录、长期无业务交易，麦小通有权予以冻结、注销等清理，您的账户将不能再登录麦小通App，相应服务同时终止。麦小通在对此类账户进行清理前，将以包括但不限于站内消息、客户端推送信息等方式通知您。
	  2.3 注册信息管理
	  2.3.1 真实合法
	  2.3.1.1 在使用麦小通服务时，您应当按麦小通系统或产品页面的提示准确完整地提供门店及操作人员信息（包括门店名称、联系电话、联系地址、联系人等），以便麦小通在必要时与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。
	  2.3.1.2 您所设置的门店名称、账号昵称不得违反国家法律法规及麦小通关于账号名称的管理规定，否则麦小通可对您的账号昵称进行暂停使用或重置等处理。昵称的重置不影响您以账号、手机号码登录麦小通系统并使用麦小通服务。
	  2.3.2 更新维护
	  2.3.2.1 您应当及时更新您提供的门店、联系人信息。在法律法规有明确规定或基于为您提供第三方服务需求要求麦小通对部分用户的信息进行核实的情况下，麦小通将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整的信息。
	  2.3.2.2 如麦小通按您最后一次提供的信息与您联系未果、您未按照麦小通的要求及时提供信息、您提供的信息存在明显不实的，您将承担因此对您自身、他人及麦小通造成的全部损失与不利后果。麦小通可对您发出询问或要求整改的通知，并要求您进行重新资质认证，直至中止、终止对您提供部分或全部麦小通服务，麦小通对此不承担责任。
	  2.3.2.3 麦小通对于您用户信息及个人信息的收集、使用、保护等内容详见《麦小通隐私政策》。
	  2.4 账户安全规范
	  2.4.1 您的账户密码由门店自行设置并由门店保管。建议您务必保管好您的帐户；您作为商户用户，请加强内部人员管理，确保您的工作人员能妥善保管您的账户信息及账户密码安全，并确保您在每个上网时段结束时退出登录并以正确步骤离开麦小通系统。
	  2.4.2 除麦小通存在过错外，您应对您账户项下的所有行为结果（包括但不限于在线提交订单、报损、调货、对账、发布反馈信息、披露信息等）负责。
	  2.4.3 您的账户只限本门店授权工作人员使用，不得出借或分享给外部他人使用。当您的账户遭到未经授权的使用时，您应当立即通知我们，否则未经授权的使用行为均视为门店本人的行为，门店将自行承担所有由此导致的损失及后果。
	  2.4.4 账户因您主动泄漏或因您遭受他人攻击、诈骗等行为导致的损失及后果，麦小通对此并不承担责任，门店应通过司法、行政等救济途径向侵权行为人追偿。
	  2.4.5 如发现任何未经授权使用您账户登录麦小通系统或其他可能导致您账户遭窃、遗失的情况，建议您立即通知麦小通。您理解麦小通对您的任何请求采取行动均需要合理时间，且麦小通应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除麦小通存在主观过错外，麦小通对在采取行动前已经产生的后果不承担任何责任。
	  3. 麦小通服务内容及规范
	  3.1 麦小通提供的服务
	  3.1.1 麦小通向您提供包括但不限于以下服务：
	  （一）麦小通App客户端服务；
	  （二）麦小通会同第三方合作伙伴、合作仓库共同向您提供的订货、配送、售后相关服务。
	  3.1.2 麦小通提供的服务均仅限于您在麦小通系统使用，未经麦小通明确同意或安排，任何以恶意破解等非法手段将麦小通服务与麦小通公司分离的行为，均不属于本协议中约定的麦小通服务。由此引起的一切法律后果由行为人负责，麦小通将依法追究行为人的法律责任。
	  3.1.3 麦小通官方公布的渠道为下载、登录、使用麦小通服务的唯一合法方式，您通过其他未经麦小通明确认可的渠道、途径、方式获取的麦小通服务（包括且不限于账户、优惠券、赠品等）均为非法取得，麦小通概不承认其效力，且一经发现麦小通有权立即做出删除、取消、清零、封号等处理，任何因此导致的一切不利后果均由您自行承担。
	  3.1.4 麦小通有权向您公告（包括但不限于弹出页面、客户端公告、站内消息、短信通知等方式）以修改、替换、升级与麦小通服务相关的任何软件、系统或服务。如果您不同意或者不接受麦小通软件、系统或服务的修改、替换、升级，请直接拒绝、停止、取消，否则视为您同意并接受麦小通软件、系统或服务的修改、替代、升级，同时该同意并接受的行为仍受本协议约束。
	  3.1.5 您理解并认可，您使用麦小通系统或麦小通账户所获得的优惠券、赠券、活动权益、积分等衍生物，您确认对其不享有所有权（除非麦小通另有公告说明），麦小通许可您按照麦小通规则进行使用，麦小通对上述衍生物不承担任何赔偿责任。
	  3.1.6 您同意并保证，不得利用麦小通服务或其衍生物（包括但不限于账户、优惠券、活动赠品等服务）进行倒卖、转手、置换、抵押有价交易等方式非法牟利。您不会利用麦小通服务或其衍生物侵犯他人的合法权益，禁止通过网络漏洞、恶意软件或其他非法手段窃取、盗用他人的帐户、优惠券等。
	  3.1.7 您理解并认可，如果您通过第三方支付工具在麦小通账户支付后可能产生的任何商业风险（包括但不限于不法分子利用您帐户或银行卡等有价卡等进行违法活动），该等风险均有可能给您造成相应的经济损失，麦小通在充分履行其在本协议项下义务和符合法律规定的前提下，不对您的前述风险和损失承担任何责任。
	  3.2 服务规范
	  3.2.1 您可通过麦小通系统服务上传、发布或传输相关反馈内容，包括但不限于文字、图片等信息或其他资料，您需对此内容承担相关的法律责任。
	  3.2.2 为方便您使用麦小通服务及麦小通与其他合作伙伴共同向您提供的服务，您授权麦小通在您注册和使用麦小通服务期间将您的必要业务信息传递给麦小通的合作伙伴及其他相关方，或从其他相关方获取您在注册、使用相关服务期间提供、形成的信息。
	  3.2.3 您理解并知晓在使用麦小通服务时，所接触的内容和信息来源广泛，麦小通无法对合作仓库货品信息的准确性、真实性、可用性、安全性、完整性和正当性做绝对担保。您理解并认可您可能会接触到不正确的信息，您不会以此追究麦小通的相关责任。麦小通不对合作仓库发布的货品内容背书、推荐或表达观点，也不对任何内容和信息的错误、瑕疵及产生的损失或损害承担任何责任，您对内容和信息的任何使用需自行承担相关的风险。但如您认为存在侵权内容，您可立即通知我们，我们会按照法律法规规定及我们与用户的约定进行相应处理。
	  3.2.4 您同意麦小通在提供服务的过程中以各种方式投放商业性广告或其他任何类型的商业信息，您同意接受麦小通通过站内短信、手机短信、客户端公告或其他方式向您发送促销或其他相关商业信息。
	  3.2.5 您同意在使用麦小通服务过程中，遵守以下法律法规：《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国电子商务法》、《中华人民共和国个人信息保护法》、《中华人民共和国计算机信息系统安全保护条例》等有关计算机及互联网规定的法律、法规。在任何情况下，麦小通一旦合理地认为您的行为可能违反上述法律、法规，可以在任何时候，不经事先通知终止向您提供服务。
	  3.3 禁止的内容
	  3.3.1 您理解并保证您在麦小通上传、发布或传输的内容（包括您的账户名称等信息）不含有以下内容：
	  （一）违反国家法律法规禁止性规定的；
	  （二）政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
	  （三）欺诈、虚假、不准确或存在误导性的报损、调货、投诉单据信息；
	  （四）侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；
	  （五）侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；
	  （六）存在可能破坏、篡改、删除、影响麦小通任何系统正常运行或未经授权秘密获取麦小通及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；
	  （七）其他违背社会公共利益或公共道德或依据相关麦小通协议、规则的规定不适合在麦小通系统上发布的。
	  3.3.2 如果您上传、发布或传输的内容含有以上违反法律法规的信息或内容的，或者侵犯任何第三方的合法权益，麦小通有权进行独立判断并采取相应措施，包括但不限于通过技术手段删除相关内容。同时，麦小通有权视您的行为性质，采取包括但不限于暂停或终止向您提供服务，追究法律责任等措施。您将直接承担以上导致的一切不利后果。如因此给麦小通造成不利后果的，您应负责消除影响，并且赔偿麦小通因此导致的一切损失，包括且不限于财产损害赔偿、名誉损害赔偿、律师费、交通费等因维权而产生的合理费用。
	  3.4 禁止的行为
	  3.4.1 您理解并保证不就麦小通服务进行下列的禁止的行为，也不允许任何人利用您的账户进行下列行为：
	  （一）在使用麦小通服务时，冒充他人，或讹称与任何人或实体有联系；
	  （二）伪造单据标题或以其他方式操控业务单据信息；
	  （三）将无权传输的内容（例如内部资料、机密资料）进行上传、发布、发送或以其他方式传输；
	  （四）发送任何未获邀约或未经授权的垃圾短信、广告或宣传资料；
	  （五）跟踪或以其他方式骚扰平台工作人员、合作仓库人员以及其他商户；
	  （六）参与任何非法或有可能非法的活动或交易，包括诈骗等；
	  （七）使用或利用麦小通知识产权（包括我们的商标、品牌、标志、任何其他专有数据），或在其他方面侵犯麦小通任何知识产权（包括试图对麦小通客户端或所使用的软件进行逆向工程）；
	  （八）通过使用任何自动化程序、软件、引擎、网络爬虫、网页分析工具、数据挖掘工具或类似工具，接入麦小通服务、刷库存、刷接口、收集或处理通过麦小通服务所提供的内容；
	  （九）参与任何“框架”、“镜像”或其他技术，目的是模仿麦小通服务的外观和功能；
	  （十）干预或试图干预任何用户或任何其他方接入麦小通服务；
	  （十一）故意散播病毒、网络蠕虫、特洛伊木马病毒、已损毁的档案或其他恶意代码或项目；
	  （十二）未经他人明确同意，分享或发布该等人士可识别个人身份的资料；
	  （十三）探究或测试麦小通服务、系统或其他用户的系统是否容易入侵攻击，或在其他方面规避麦小通服务、系统的任何安全功能；
	  （十四）对麦小通服务所用的软件进行解编、反向编译或逆向工程，或试图作出上述事项；
	  （十五）为破坏或滥用的目的开设多个账户，或恶意上传重复的、无效的大容量数据和信息；
	  （十六）恶意刷单、虚假下单、恶意套取优惠券补贴、恶意取消订单，扰乱订货业务秩序；
	  （十七）故意或非故意违反任何相关的中国法律、法规、规章、条例等其他具有法律效力的规范。
	  3.5 订货、收货与售后业务规则
	  3.5.1 用户提交订单前，应当仔细核对商品品类、规格、数量、收货门店、联系人、联系电话等全部订单信息，确认无误后提交。
	  3.5.2 货品送达门店后，门店应当现场清点验货，核对货品数量、规格、品相、包装。如发生错发、漏发、破损、变质，应当场拒收并及时在平台提交售后或联系客服。
	  3.5.3 门店确认签收，即代表本次配送货品已经门店现场验收核对无误。签收之后发生的损耗、保管问题，由门店自行承担经营风险。
	  3.5.4 B端商业订货不同于普通消费者网购，非货品质量、破损、错漏发问题，不支持无理由退换货。
	  3.5.5 如您未手动确认收货，系统将在原有自动收货时长基础上额外增加5天后自动确认收货；订单有售后退款时自动收货计时暂停。自动收货完成后，视为门店已验收货品无误，订单正式完结，门店不得再以未验货、未收货为由提出异议。
	  4．第三方链接与第三方服务
	  麦小通服务可能会包含与其他网站或资源的链接，如支付宝、微信支付等第三方支付服务。麦小通对于前述网站或资源的内容、隐私政策和活动，无权控制、审查或修改，因而也不承担任何责任。麦小通建议您在访问其他网站或资源前仔细阅读其服务条款和隐私政策。
	  5．信息收集及使用
	  5.1 信息的收集
	  5.1.1 为了向用户提供更好、更优、更个性化的服务，您同意并授权麦小通公司根据本协议及其他法律法规合法、正当地收集并使用您在麦小通系统上所留下的与麦小通服务相关的必要信息。
	  5.1.2 当您在麦小通系统创建账户使用服务时，麦小通会记录您向麦小通提供的各类信息，包括但不限于手机号、店铺名称、店铺地址、联系人信息、订货订单信息、报损调货单据、支付记录；同时，麦小通还会记录您在使用麦小通服务时提供的信息，例如搜索关键词信息、您与麦小通客服联系时所提供的相关信息。
	  5.1.3 更多关于用户信息及个人信息的收集内容详见《麦小通隐私政策》。
	  5.2 信息的使用
	  5.2.1 当您与麦小通或麦小通第三方合作伙伴之间互动时，本着共同向用户提供服务及改进服务质量的合理需要，也为了风险防控，以及保护各方的合法权益，用户同意麦小通公司或第三方合作伙伴在必要时将以上必要信息用于如下用途：
	  5.2.1.1 在您使用麦小通服务过程中，为向您提供订货、调货、报损、对账服务，并持续维护、改善、优化这些服务，包括但不限于对您的信息进行分析和处理、或将您的信息用于数据统计分析；
	  5.2.1.2 用于预防、发现、调查欺诈、危害安全、非法或违反与麦小通相关协议、政策或规则的行为，以保护您、麦小通公司其他用户、麦小通公司关联方或第三方合作伙伴的合法权益。
	  5.2.2 我们可能对外公开并与我们的合作伙伴分享经统计加工后不含身份识别内容的信息，用于了解您如何使用麦小通服务或让公众了解麦小通服务的总体使用趋势。
	  5.2.3 我们可能会将某项服务的信息与来自其他服务的信息结合起来，以便为您提供更优质的服务、内容和建议。
	  5.2.4 如果为了向您提供服务而需要将您的信息共享至第三方，我们将评估该第三方收集信息的合法性、正当性、必要性。我们将要求第三方对您的信息采取保护措施并且严格遵守相关法律法规、及本协议要求。另外，如我们需从第三方处获取您的信息，我们将要求第三方说明信息来源，并要求第三方保障其提供信息的合法性。同时，我们也会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗提示等形式征得您的同意或确认第三方已经征得您的同意。
	  5.2.5 我们会根据相关法律法规及监管规定对您的信息承担保护义务，并对关联公司或第三方合作伙伴进行数据安全能力审核，要求他们按照本协议及相关隐私政策采取保密和安全措施。
	  5.2.6 您同意麦小通可使用您个人信息（包括但不限于电话号码、短信等方式）向您推销/推广麦小通或麦小通关联机构、麦小通合作方的产品、服务，您可以后续在设置内选择关闭营销通知。
	  5.3 信息的共享
	  5.3.1基于向您提供订货、配送、售后服务，提升您使用麦小通平台的体验，为完成货品配送，您同意麦小通向合作仓库、物流服务商提供必要的门店收货信息、订单信息，用于履约配送。前述合作方仅可用于完成本次业务履约，不得将信息挪作其他用途。
	  5.3.2为了改善产品服务，让您得到更好的用户体验，麦小通会将数据处理及储存交由合规的云服务商进行处理。基于对数据的储存及处理，您使用麦小通App服务过程中提供、形成的信息，会传输至实际处理的云服务商，云服务商仅做存储与技术处理，不会挪作其他商业用途。
	  6．知识产权
	  6.1除非另有约定或麦小通另行声明，麦小通的所有内容（用户依法享有版权的内容除外）、技术、软件、程序、数据及其他信息（包括但不限于文字、图像、图片、照片、图表、色彩、版面设计、电子文档）的所有知识产权（包括但不限于版权、商标权、专利权、商业秘密等）及相关权利，均归杭州麦田熊科技有限公司所有。未经麦小通许可，任何人不得擅自使用（包括但不限于复制、传播、展示、镜像、上载、下载、修改、出租）。
	  6.2麦小通文字、图形及其组合，以及麦小通的其他标识、徵记、产品和服务名称均为杭州麦田熊科技有限公司在中国的商标，未经麦小通书面授权，任何人不得以任何方式展示、使用或作其他处理，也不得向他人表明您有权展示、使用或作其他处理。
	  6.3麦小通对其专有内容、原创内容和其他通过授权取得的独占或独家内容享有完全知识产权。未经麦小通许可，任何单位和个人不得私自转载、传播和提供观看服务或者有其他侵犯麦小通知识产权的行为，否则将承担所有相关的法律责任。
	  7．用户的违约及处理
	  7.1违约认定
	  发生如下情形之一的，视为您违约：
	  7.1.1使用麦小通服务时违反有关法律法规规定的；
	  7.1.2违反本协议或本协议补充协议约定的。
	  7.2为适应互联网行业发展和满足海量用户对高效优质服务的需求，您理解并同意，麦小通可在麦小通规则中约定违约认定的程序和标准。麦小通可依据您的用户数据与海量用户数据的关系来认定您是否构成违约；您有义务对您的数据异常现象进行充分举证和合理解释，否则将被认定为违约。
	  7.3违约处理措施
	  7.3.1您在麦小通提交、发布的内容和单据信息构成违约的，麦小通可根据相应规则立即对相应内容和信息进行删除、屏蔽等处理或对您的账户进行暂停使用、查封、删除等处理。
	  7.3.2您在麦小通系统上实施的行为，或虽未在麦小通系统上实施但对麦小通系统及其他用户产生影响的行为构成违约的，麦小通可依据相应规则对您的账户执行限制参加活动、中止向您提供部分或全部服务等处理措施。如您的行为构成根本违约的，麦小通可查封您的账户，终止向您提供服务。
	  7.3.3如果您在麦小通系统上的行为违反相关的法律法规，麦小通可依法向相关主管机关报告并提交您的使用记录和其他信息。
	  7.3.4麦小通可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在麦小通平台上予以公示。
	  7.4赔偿责任
	  7.4.1如您的行为使麦小通遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿麦小通的上述全部损失。
	  7.4.2如您的行为使麦小通遭受第三人主张权利，麦小通可在对第三人承担金钱给付等义务后就全部损失向您追偿。
	  7.5特别约定
	  7.5.1麦小通负责"按现状"和"可得到"的状态向您提供麦小通服务。麦小通依法律规定承担相应义务，但无法对由于信息网络设备维护、连接故障，电脑、通讯或其他系统的故障，黑客活动、计算机病毒、电力故障，通讯网络故障、罢工，暴乱，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或因第三方原因，以及在麦小通已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素而给您造成的损害结果承担责任。
	  7.5.2麦小通通过中华人民共和国境内的设施控制和提供麦小通服务，麦小通不担保控制或提供的服务在其他国家或地区是适当的、可行的，任何在其他司法辖区使用麦小通服务的用户应自行确保其遵守当地的法律法规，麦小通对此不承担任何责任。
	  8．协议的变更
	  8.1麦小通可根据国家法律法规变化及麦小通服务变化的需要，不时修改本协议、补充协议，变更后的协议、补充协议将通过本协议约定的方式通知您。
	  8.2如您对变更事项不同意的，您应当于变更事项确定的生效之日起停止使用麦小通服务；如您在变更事项生效后仍继续使用麦小通服务，则视为您同意已生效的变更事项。重大变更会以弹窗形式要求用户重新确认。
	  9．通知
	  您同意麦小通以以下合理的方式向您送达各类通知：
	  （一）客户端公示的文案；
	  （二）站内消息、弹出消息、客户端推送的消息；
	  （三）根据您预留于麦小通系统的联系方式发出的手机短信。
	  你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使通知无法送达或未及时送达，由您自行承担由此可能产生的法律后果。
	  10．协议的终止
	  10.1终止的情形
	  您有权通过以下任一方式终止本协议：
	  （一）在满足麦小通公示的账户注销条件时您通过客户端申请注销您的账户的；
	  （二）变更事项生效前您停止使用并明示不愿接受变更事项的；
	  （三）您明示不愿继续使用麦小通服务，且符合终止条件的。
	  出现以下情况时，麦小通可以本协议所列的方式通知您终止本协议：
	  （一）您违反本协议约定，麦小通依据违约条款终止本协议的；
	  （二）您转让本人账户、盗用他人账户、发布违禁内容和信息、骗取他人财物、采取不正当手段谋利等行为，麦小通依据麦小通规则对您的账户予以查封的；
	  （三）除上述情形外，因您多次违反麦小通规则相关规定且情节严重，麦小通依据麦小通规则对您的账户予以查封的；
	  （四）您的账户被麦小通依据本协议进行注销等清理的；
	  （五）您在麦小通有侵犯他人合法权益或其他严重违法违约行为的；
	  （六）其它根据相关法律法规麦小通应当终止服务的情况。
	  10.2协议终止后的处理
	  本协议终止后，除法律有明确规定外，麦小通无义务向您或您指定的第三方披露您账户中的任何信息。
	  本协议终止后，麦小通享有下列权利：
	  （一）停止收集和使用您的个人信息，但可继续保存法律规定需要留存的订单、交易、对账记录；
	  （二）对于您过往的违约行为，麦小通仍可依据本协议向您追究违约责任。
	  11．法律适用、管辖与其他
	  11.1本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国法律；如法律无相关规定的，参照商业惯例及/或行业惯例。
	  11.2您因使用麦小通服务所产生及与麦小通服务有关的争议，由麦小通与您协商解决。协商不成时，任何一方均可向杭州麦田熊科技有限公司所在地有管辖权的人民法院提起诉讼。
	  11.3本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。
	  `,
    };
  },
  methods: {},
};
</script>
<style scoped>
.agreement-container {
  padding: 20px;
  line-height: 1.6;
  font-size: 14px;
  color: #333;
}
.agreement-content {
  white-space: pre-wrap;
}
</style>